"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.defaultModifiers = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactPopper = require("react-popper");

var _Layers = require("../Layers");

var _hooks = require("../../hooks");

var _utils = require("../../../utils");

var defaultModifiers = [{
  name: 'preventOverflow'
}, {
  name: 'flip',
  options: {
    padding: 0
  }
}, {
  name: 'eventListeners',
  options: {
    scroll: true,
    resize: true
  }
}];
exports.defaultModifiers = defaultModifiers;
var PopOver = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _useClassNames = (0, _hooks.useClassNames)(props),
      classNames = _useClassNames.classNames,
      className = _useClassNames.className,
      restProps = (0, _objectWithoutPropertiesLoose2.default)(_useClassNames, ["classNames", "className"]);

  var children = restProps.children,
      content = restProps.content,
      initialVisible = restProps.initialVisible,
      closeOnContentClick = restProps.closeOnContentClick,
      triggerEvent = restProps.triggerEvent,
      TriggerTag = restProps.TriggerTag,
      ContentTag = restProps.ContentTag,
      onOpen = restProps.onOpen,
      onClose = restProps.onClose,
      modifiers = restProps.modifiers,
      placement = restProps.placement,
      otherOptions = (0, _objectWithoutPropertiesLoose2.default)(restProps, ["children", "content", "initialVisible", "closeOnContentClick", "triggerEvent", "TriggerTag", "ContentTag", "onOpen", "onClose", "modifiers", "placement"]);

  var _useState = (0, _react.useState)(initialVisible),
      visible = _useState[0],
      setVisible = _useState[1];

  var _useState2 = (0, _react.useState)(null),
      referenceElement = _useState2[0],
      setReferenceElement = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      popperElement = _useState3[0],
      setPopperElement = _useState3[1];

  var _useState4 = (0, _react.useState)(null),
      arrowElement = _useState4[0],
      setArrowElement = _useState4[1];

  var _usePopper = (0, _reactPopper.usePopper)(referenceElement, popperElement, (0, _extends2.default)({
    placement: placement,
    modifiers: modifiers
  }, otherOptions)),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes,
      update = _usePopper.update,
      forceUpdate = _usePopper.forceUpdate,
      state = _usePopper.state;

  (0, _react.useImperativeHandle)(ref, function () {
    return {
      setVisible: setVisible,
      visible: visible,
      referenceElement: referenceElement,
      popperElement: popperElement,
      arrowElement: arrowElement,
      update: update,
      forceUpdate: forceUpdate,
      state: state
    };
  });
  var open = (0, _react.useCallback)(function (event) {
    setVisible(true);
    onOpen(event);
  }, [onOpen]);
  var close = (0, _react.useCallback)(function (event) {
    setVisible(false);
    onClose(event);
  }, [onClose]);
  var toogle = (0, _react.useCallback)(function (event) {
    if (visible) {
      close(event);
    } else {
      open(event);
    }
  }, [visible, open, close]);
  var clickAway = (0, _react.useCallback)(function (event) {
    if (visible && popperElement && !popperElement.contains(event.target) && referenceElement && !referenceElement.contains(event.target)) {
      close(event);
    }

    return event;
  }, [visible, referenceElement, popperElement, close]);
  var handleTriggerClick = (0, _react.useCallback)(function (event) {
    toogle(event);
  }, [toogle]);
  var handleContentClick = (0, _react.useCallback)(function (event) {
    if (closeOnContentClick) {
      close(event);
    }
  }, [close, closeOnContentClick]);
  var handleMouseEnter = (0, _react.useCallback)(function (event) {
    if (triggerEvent === 'hover') {
      open(event);
    }
  }, [triggerEvent, open]);
  var handleMouseLeave = (0, _react.useCallback)(function (event) {
    if (triggerEvent === 'hover') {
      close(event);
    }
  }, [triggerEvent, close]);
  (0, _react.useEffect)(function () {
    if (triggerEvent === 'click' && visible) {
      document.addEventListener('click', clickAway, true);
    }

    return function () {
      document.removeEventListener('click', clickAway, true);
    };
  }, [triggerEvent, visible, clickAway, ref]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(TriggerTag, {
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    className: (classNames('trigger', {
      visible: visible
    }) + " " + className).trim(),
    onClick: handleTriggerClick,
    ref: setReferenceElement
  }, children), visible && /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement(ContentTag, (0, _extends2.default)({
    ref: setPopperElement
  }, attributes.popper, {
    className: (classNames([{
      placement: placement
    }, {
      visible: visible
    }]) + " " + className).trim(),
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onClick: handleContentClick
  }, attributes.popper, {
    style: (0, _extends2.default)({}, styles.popper, {
      display: visible ? "block" : 'none'
    })
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classNames('content')
  }, content), /*#__PURE__*/_react.default.createElement("div", {
    ref: setArrowElement,
    className: classNames('arrow')
  })), document.getElementById(_Layers.popOverLayerId)));
});
PopOver.propTypes = {
  /** It describes a standalone entity that is meaningful on its own. It will be used to generate the component className. */
  alias: _propTypes.default.string,

  /** It extends component styles. */
  className: _propTypes.default.string,

  /** Parent PopOver */
  children: _propTypes.default.node,

  /** PopOver content */
  content: _propTypes.default.node,

  /** Describes the placement of your [Popper](https://www.npmjs.com/package/react-popper#placement) */
  placement: _propTypes.default.string,

  /** An array containing custom settings for the [Popper.js](https://popper.js.org/popper-documentation.html#Popper.Defaults.modifiers) modifiers. */
  modifiers: _propTypes.default.array,

  /** Event triggered when PopOver is closed. */
  onClose: _propTypes.default.func,

  /** Event triggered when PopOver is closed. */
  onOpen: _propTypes.default.func,

  /** If true, PopOver will be visible */
  initialVisible: _propTypes.default.bool,

  /** Set to render a custom trigger tag */
  TriggerTag: _propTypes.default.elementType,

  /** Set to render a custom content tag */
  ContentTag: _propTypes.default.elementType,

  /** Event which toggle PopOver visibility */
  triggerEvent: _propTypes.default.oneOf(['click', 'hover']),

  /** If true, PopOver will close when content is clicked */
  closeOnContentClick: _propTypes.default.bool
};
PopOver.defaultProps = {
  alias: 'PopOver',
  className: '',
  triggerEvent: 'click',
  placement: 'bottom',
  modifiers: defaultModifiers,
  onOpen: _utils.noop,
  onClose: _utils.noop,
  TriggerTag: 'a',
  ContentTag: 'div'
};
PopOver.displayName = 'PopOver';
var _default = PopOver;
exports.default = _default;